import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";


export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: "1",
        p: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        my: "50px"
    };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
    return {
      backgroundColor: { xs: "#F9F9F9", sm: "transparent" },
      px: { xs: "1rem", sm: "3rem", md: "0", lg: "3rem" },
      maxWidth: { xs: "390px", sm: "500px", md: "550px" },
      textAlign: "center"
    };
}

export function cardCSS(theme: Theme): SxProps<Theme> {
    return {
      px: "4rem",
      py: "20px",
      borderRadius: "30px",
      width: { xs: "200px", md: "500px", lg: "600px" },
      minHeight: 400
    };
}

export function stepper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%", 
        maxWidth: { xs: "390px", sm: "500px", md: "100%" },
        mb: "50px"
    };
}

export function infotext(theme: Theme): SxProps<Theme> {
    return {
        textAlign: "justify", 
        whiteSpace: "pre-wrap"
    };
}